import { render, staticRenderFns } from "./AvatarUser.vue?vue&type=template&id=76998c4a&scoped=true&"
import script from "./AvatarUser.vue?vue&type=script&lang=js&"
export * from "./AvatarUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76998c4a",
  null
  
)

export default component.exports